var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"smvp-error-notification"},[_c('div',{staticClass:"smvp-message",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }